<template>
  <nav class="border-t border-gray-150 px-0 flex items-center justify-between">
    <div>
      <base-select :options="rowOptions" :model-value="modelValue.take" @update:model-value="updateTake" />
    </div>
    <div class="flex items-center flex-grow justify-end -mt-2.5 md:-mt-2.5">
      <div class="flex flex-shrink-0">
        <button
          class="-mt-px border-t-2 border-transparent pt-3.5 sm:pt-2.5 md:pt-3 pr-1 inline-flex items-center text-sm leading-5 font-normal text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-400 transition ease-in-out duration-150"
          @click="goToPrevious"
        >
          <arrow-left-icon class="h-4 w-4 mr-1.5" />Previous
        </button>
      </div>
      <div class="hidden md:flex">
        <base-pagination-tab v-for="page in leftPages" :key="`left-${page}`" @click="updatePage(page)" :is-selected="page === currentPage">{{ page }}</base-pagination-tab>
        <div class="flex" v-if="exceededMax">
          <div class="text-gray-500 pt-3">...</div>
          <div class="flex" v-if="showMiddlePages">
            <base-pagination-tab v-for="page in middlePages" :key="`middle-${page}`" @click="updatePage(page)" :is-selected="page === currentPage">{{ page }}</base-pagination-tab>
          </div>
          <div class="text-gray-500 pt-3" v-if="showMiddlePages">...</div>
          <base-pagination-tab v-for="page in rightPages" :key="`right-${page}`" @click="updatePage(page)" :is-selected="page === currentPage">{{ page }}</base-pagination-tab>
        </div>
      </div>
      <div class="flex justify-end">
        <button
          class="-mt-px border-t-2 border-transparent pt-3.5 sm:pt-2.5 md:pt-3 pl-1 inline-flex items-center text-sm leading-5 font-normal text-gray-500 hover:text-gray-700 hover:border-gray-300 focus:outline-none focus:text-gray-700 focus:border-gray-400 transition ease-in-out duration-150"
          @click="goToNext"
        >
          Next
          <arrow-right-icon class="h-4 w-4 ml-1.5" />
        </button>
      </div>
    </div>
  </nav>
</template>

<script>
import BasePaginationTab from "@/components/base/BasePaginationTab";
import BaseSelect from "@/components/base/BaseSelect";
import { ArrowLeftIcon, ArrowRightIcon } from "@/assets/svgs";
const MAX_TABS = 10;
export default {
  components: {
    ArrowLeftIcon,
    ArrowRightIcon,
    BasePaginationTab,
    BaseSelect,
  },
  props: {
    modelValue: Object,
  },
  data() {
    return {};
  },
  computed: {
    rowOptions() {
      var options = [10, 20, 50, 100];
      if (options.includes(+this.modelValue.take))
        return [
          { value: 10, label: 10 },
          { value: 20, label: 20 },
          { value: 50, label: 50 },
          { value: 100, label: 100 },
        ];
      else
        return [
          { value: this.modelValue.take, label: this.modelValue.take },
          { value: 10, label: 10 },
          { value: 20, label: 20 },
          { value: 50, label: 50 },
          { value: 100, label: 100 },
        ].sort((a, b) => a.value - b.value);
    },
    exceededMax() {
      return this.totalPages >= MAX_TABS;
    },
    leftPages() {
      if (!this.exceededMax) {
        return this.totalPages;
      }
      if (this.currentPage > 3) {
        return 1;
      }
      if (this.currentPage === 3) {
        return 4;
      }
      return 3;
    },
    showMiddlePages() {
      return this.currentPage > 3 && this.currentPage < this.totalPages - 2;
    },
    middlePages() {
      return [this.currentPage - 1, this.currentPage, this.currentPage + 1];
    },
    rightPages() {
      if (this.currentPage < this.totalPages - 2) {
        return [this.totalPages];
      }
      if (this.currentPage === this.totalPages - 2) {
        return [this.totalPages - 3, this.totalPages - 2, this.totalPages - 1, this.totalPages];
      }
      return [this.totalPages - 2, this.totalPages - 1, this.totalPages];
    },
    totalPages() {
      return +Math.ceil(this.modelValue.total / this.modelValue.take);
    },
    currentPage() {
      return Math.floor(this.modelValue.skip / this.modelValue.take) + 1;
    },
  },
  methods: {
    updatePage(page) {
      if (this.currentPage !== page) {
        this.$emit("update:modelValue", {
          ...this.modelValue,
          skip: this.modelValue.take * (page - 1),
        });
      }
    },
    goToPrevious() {
      if (this.currentPage !== 1) {
        this.$emit("update:modelValue", {
          ...this.modelValue,
          skip: this.modelValue.skip - this.modelValue.take,
        });
      }
    },
    goToNext() {
      if (this.currentPage !== this.totalPages) {
        this.$emit("update:modelValue", {
          ...this.modelValue,
          skip: this.modelValue.skip + this.modelValue.take,
        });
      }
    },
    updateTake(take) {
      this.$emit("update:modelValue", {
        ...this.modelValue,
        skip: Math.floor(this.modelValue.skip / take) * take,
        take: +take,
      });
    },
  },
};
</script>
